/** Notifications returned in response to an action the user took. */
export enum NotificationType {
  /** The process completely broke while trying to complete. */
  error = 'error',
  /** More information about something the user is looking into. */
  info = 'info',
  /** The process finished successfully without finding any issues.. */
  success = 'success',
  /** The process finished, but issues were spotted along the way. */
  warning = 'warning'
}
